import React from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import technical from './assets/images/technical.png';
import XamppControl from './assets/images/xampp-control.png';
import phpInstall from './assets/images/php-install.png';



const PhpLesson2 = () => {
  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">


    <div className="alert alert-secondary" role="alert">
    <h3><strong>What is XAMPP?</strong></h3>
     <p><b>XAMPP</b> is a free and open-source local web server solution stack package developed by Apache Friends,
     consisting mainly of the Apache HTTP Server, MariaDB database, and interpreters for scripts written in the PHP and Perl programming languages.</p>
     <p>XAMPP stands for <b>Cross-Platform (X), Apache (A), MariaDB (M), PHP (P) and Perl (P).</b> It is a simple, lightweight Apache distribution that makes
     it easy for developers to create a local web server for testing purposes. XAMPP is available for Windows, Linux, and MacOS.</p>
     <p>XAMPP provides an easy way to install and set up a local web server environment on your computer. It is often used by developers to test web applications or websites before they are deployed to a live server.</p>
    <p>It is also useful for learning web development technologies,
     such as PHP, MySQL, and Apache, as you can set up a local development environment and experiment with these technologies without the need for a live
     internet connection.</p>
     </div>

     <div className="alert alert-secondary" role="alert">
     <h3><strong>How to Install XAMPP</strong></h3>

     <p>To install XAMPP, follow these steps:</p>
    <ol class="list-group list-group-numbered mb-4">
  <li class="list-group-item">Download the latest version of XAMPP from the Apache Friends website (https://www.apachefriends.org/index.html).</li>
  <li class="list-group-item">Run the downloaded installer file.</li>
  <li class="list-group-item">Follow the prompts to install XAMPP. You will be asked to choose the components you want to install and the location for the installation.
  Make sure to select the Apache and MySQL modules as these are necessary for running a local server.</li>
      <li class="list-group-item">In the Control Panel, start the Apache and MySQL modules by clicking on the "Start" buttons next to them.</li>
  <li class="list-group-item">To test if XAMPP is working properly, open a web browser and enter the URL "http://localhost" into the address bar.
  You should see the XAMPP dashboard, which means that XAMPP is up and running on your machine.</li>
    </ol>

<ol>
    <li class="list-group-item">In the Control Panel, start the Apache and MySQL modules by clicking on the "Start" buttons next to them.</li>
  <li class="list-group-item">To test if XAMPP is working properly, open a web browser and enter the URL "http://localhost" into the address bar.
  You should see the XAMPP dashboard, which means that XAMPP is up and running on your machine.</li>
    </ol>
    <img src={XamppControl} alt="install PHP" className="img-fluid" />

    <img src={phpInstall} alt="install PHP" className="img-fluid mb-4" />
    <p>That's it! You have successfully installed XAMPP on your system.</p>
    <p>You can now use it to run a local server and develop web applications on your own computer.</p>
    <p>Note also that to run your php script, you should first create a folder that will hold your project.</p>
    <p><b>Go to XAMPP -&gt; htdocs -&gt; your_folder</b></p>
    <p><b>Create a file with a <i>.php</i> extension. If your file contains any php code, the file extension must be a <i>.php</i>, whether or not you have html code in it.</b></p>






    </div>




    </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}
export default PhpLesson2
